module.exports = __webpack_public_path__ + "img/google-icon.95e2a6d0.svg";